<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>

<script>
import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('setuppattern.patternsetuplist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('columns.code'), value: "code", width: "120px" },
        { text: this.$t('setuppattern.name'), value: "name", width: "200px" },
        { text: this.$t('setuppattern.cycledays'), value: "cycledays", width: "120px" },
        { text: this.$t('columns.remark'), value: "remark", width: "200px" },
        { text: this.$t('columns.disable'), value: "disabledesc", width: "100px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getPatternListHandler() {
      const vm = this;

      this.loading = true;

      this.$store.dispatch("get", { url: "/patternsetup/all" })
        .then(res => {
          for (let i = 0; i < res.data.rec.length; i++) {
            vm.dataItems.push({
              id: res.data.rec[i].id,
              code: res.data.rec[i].code,
              name: res.data.rec[i].name,
              cycledays: res.data.rec[i].cycledays,
              remark: res.data.rec[i].remark,
              disabledesc: res.data.rec[i].disabledesc,
            });
          }
          vm.loading = false;
        })
        .catch(err => {
          vm.errMsg = err;
          vm.loading = false;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "patternsetupedit", params: { id: item.id, search: item.search } });
    },

    deleteItemHandler(item) {
      console.log(item);
      // delete handled from edit page
    },

    newRecordHandler() {
      this.$router.push({ name: "patternsetupnew" });
    },
  },

  mounted() {
    this.getPatternListHandler();
  },
};
</script>
